import { render, staticRenderFns } from "./ThemesEditorFooter.vue?vue&type=template&id=55bde7d9&scoped=true"
import script from "./ThemesEditorFooter.vue?vue&type=script&setup=true&lang=js"
export * from "./ThemesEditorFooter.vue?vue&type=script&setup=true&lang=js"
import style0 from "./ThemesEditorFooter.vue?vue&type=style&index=0&id=55bde7d9&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "55bde7d9",
  null
  
)

export default component.exports